import type { TabConfig } from './tabs';
import { TABS } from './tabs';

export function getTabs(): readonly TabConfig[] {
	return TABS;
}
